import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const PeopleSearchBarWrapper = styled.div`
  min-height: 105px;
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  padding: 12px 45px 12px 24px;

  ${BREAKPOINTS.tablet} {
    height: 100%;
    padding: 12px;
    align-items: flex-start;
  }
`;

export const PeopleSearchBarContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const PeopleSearchBarTabTitle = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-data-skill-foreground);
`;

export const PeopleSearchBarInput = styled.textarea`
  width: 100%;

  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  &::placeholder {
    font-weight: 400;
    font-size: 18px;
    line-height: normal;

    ${BREAKPOINTS.tablet} {
      font-size: 16px;
    }

    color: rgba(23, 28, 51, 0.5);
  }

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  color: var(--color-primary);

  border: none;
  resize: none;

  &:focus {
    outline: none;
  }

  background: none;
`;

export const PeopleSearchBarIconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
  }
`;

export const PeopleSearchBarSearchIcon = styled.div`
  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;

  ${({ theme }) =>
    !theme.hasSearchValue
      ? `
    background: var(--color-data-alumni-background);

    & > svg > path {
      stroke: rgba(255, 255, 255, 0.5);
    }
  `
      : `
    background: var(--color-primary);
    cursor: pointer;
  `}
`;

export const PeopleSearchBarFilterIcon = styled.div`
  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  cursor: pointer;
`;

export const PeopleSearchBarClearPromptIcon = styled.div`
  width: 22px;
  height: 22px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  background: rgba(217, 217, 217, 0.5);

  cursor: pointer;
`;

export const PeopleSearchBarFilterIconAmount = styled.span`
  height: 18px;

  position: absolute;
  top: 0px;
  right: 0px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0px 4px;
  border-radius: 4px;
  background: var(--color-data-skill-background);

  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: var(--color-text);

  transform: translate(25%, -50%);
`;

export const PeopleSearchBarResetFiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 2px;

  cursor: pointer;
`;

export const PeopleSearchBarResetFiltersLabel = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;
  text-wrap: nowrap;

  color: rgba(23, 28, 51, 0.5);
`;

// FILTERS OPEN
export const PeopleSearchBarFiltersOpenTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const PeopleSearchBarFiltersOpenTitle = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;

export const PeopleSearchBarFiltersOpenTitleResetContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;
`;

export const PeopleSearchBarFiltersOpenTitleReset = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

export const PeopleSearchBarFiltersOpenFilterIcon = styled(PeopleSearchBarFilterIcon)`
  border-radius: 100%;
  background: var(--color-primary);
`;

export const PeopleSearchBarFiltersOpenSearchIcon = styled(PeopleSearchBarFilterIcon)``;

export const PeopleSearchBarFiltersOpenBackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;
`;

export const PeopleSearchBarFiltersOpenBackIconContainer = styled.div`
  width: 24px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PeopleSearchBarFiltersOpenBackLabel = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;

  color: var(--color-text);
`;

// CURRENT FILTERS
export const PeopleSearchBarCurrentFiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 4px;

  ${BREAKPOINTS.tablet} {
    padding: 8px 0px 12px 12px;
  }
`;

export const PeopleSearchBarCurrentFiltersContainer = styled.span``;

export const PeopleSearchBarCurrentFiltersTitle = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;

  color: var(--color-data-skill-foreground);
`;

export const PeopleSearchBarCurrentFiltersValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: normal;

  color: var(--color-data-skill-foreground);
`;

// MINIMAL STATE
export const PeopleSearchBarMinimalStateWrapper = styled.div`
  width: 100%;
  max-height: 343px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  padding: 10px;

  border-radius: 8px;
  background: ${({ theme }) =>
    (theme.currentStep === 1 || theme.isFocused) && !theme.isLoading
      ? '#ffffff'
      : 'rgba(255, 255, 255, 0.50)'};

  ${({ theme }) =>
    theme.currentStep === 1 &&
    !theme.isLoading &&
    `
    min-height: 103px;
    align-items: flex-start;

   
  `}

  ${({ theme }) =>
    theme.isHistoryOpen &&
    `
    border-radius: 8px 8px 0px 0px;

    ${BREAKPOINTS.large_tablet_landscape} {
      align-items: flex-start;
      min-height: 103px;
    }
  `}

  ${({ theme }) =>
    theme.currentStep !== 1 &&
    `
    align-self: center;
  `}
`;

export const PeopleSearchBarMinimalStateContainer = styled.div`
  flex: 1;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;

  ${BREAKPOINTS.tablet} {
    gap: 6px;
  }
`;

export const PeopleSearchBarMinimalStateResetContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;

export const PeopleSearchBarMinimalStateInformationContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PeopleSearchBarMinimalStateGroupsWrapper = styled(motion.div)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

export const PeopleSearchBarMinimalStateGroupContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  padding: 2px 8px 2px 3px;
`;

interface PeopleSearchBarMinimalStateGroupLabelProps {
  isUnrecognized?: boolean;
}

export const PeopleSearchBarMinimalStateGroupLabel = styled.span<PeopleSearchBarMinimalStateGroupLabelProps>`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: ${({ isUnrecognized }) =>
    isUnrecognized ? 'rgba(23, 28, 51, 0.3)' : 'rgba(23, 28, 51, 0.5)'};
`;

export const PeopleSearchBarMinimalStatePrompt = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;

// TABLET
export const PeopleSearchBarTabletLabel = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-data-alumni-background);
`;

export const PeopleSearchBarTabletGroupsContainer = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  padding: 5px 10px;

  border-radius: 8px;
  background: rgba(255, 255, 255, 0.2);
`;

export const PeopleSearchBarTabletGroupsLabel = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  white-space: nowrap;

  color: rgba(23, 28, 51, 0.5);
`;
